import { GQLResponseServerError } from '@change-corgi/core/gql';

/**
 * Whether the request failed before reaching our GraphQL server (e.g. a client-side proxy or CDN error).
 * Those are already reported by the GQL fetch layer, and are not actionable by callers.
 */
export function isNonGraphqlServerError(error: unknown): boolean {
	if (!(error instanceof GQLResponseServerError)) return false;
	// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- ServerError.response is a fetch Response
	const response = error.response as Response | undefined;
	return response?.headers.get('x-graphql') !== 'true';
}
